"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _JssProvider = _interopRequireDefault(require("react-jss/lib/JssProvider"));
var _GlobalFunctions = _interopRequireDefault(require("GlobalFunctions"));
var _Application = _interopRequireDefault(require("Application"));
var _jss = require("jss");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let app = window.app;
const generateClassName = (0, _styles.createGenerateClassName)();
const jss = (0, _jss.create)((0, _styles.jssPreset)());

// We define a custom insertion point that JSS will look for injecting the styles in the DOM.
jss.options.insertionPoint = 'JSS';

// https://material-ui.com/customization/default-theme/
const theme = (0, _styles.createMuiTheme)({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      main: '#22a2b5',
      light: '#28b9ce',
      dark: '#003f66'
    },
    secondary: {
      main: '#ef7c01'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1326,
      xl: 1400
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
  let app_container = document.getElementById('app');
  if (!app_container) return console.error('missing #app <div> on the page');
  app_container.addEventListener('click', function () {
    app.emit({
      event: 'documentClick'
    });
  });
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_JssProvider.default, {
    jss: jss,
    generateClassName: generateClassName
  }, /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Application.default, null))), app_container);
});
